import React from "react"
import { BrowserRouter as Router, Route, Switch } from "react-router-dom"
import { Provider } from "react-redux"
import { MuiThemeProvider } from "@material-ui/core/styles"
import { I18nextProvider } from "react-i18next"

//import views
import ProductDetails from "./views/ProductDetails"
import PlaceBids from "./views/PlaceBids"
import ContactUs from "./views/ContactUs"
import TrendingBids from "./views/TrendingBids"
import DailyBids from "./views/DailyBids"
import WeeklyBids from "./views/WeeklyBids"

import AllBids from "./views/AllBids"
import InviteAndEarn from "./views/InviteAndEarn"
import TermsAndConditions from "./views/TermsAndConditions"
import Testimonials from "./views/Testimonials"
import HowBidWorks from "./views/HowBidWorks"
import MyBids from "./views/MyBids"
import ExpiredBids from "./views/MyBids/expired-bids"
import DataSaver from "./views/DataSaver"
import EnableCookie from "./views/EnableCookie"

import Store from "./store"
import FullPageLoader from "./components/loaders/FullPageLoader"
import Toast from "./components/Toast"
import Popup from "./components/Popup"
import WithLogin from "./components/WithLogin"
import i18n from "./i18n"
import theme from "./theme"
import Main from "./Main"
import Cookie from "./util/Cookie"
import { isUser } from "./util/CheckUser"
import OneSignal from "./OneSignal"
import NoWifiPage from "./views/NoWifiPage"
import LandingPageTermsAndConditions from "./views/LandingPageTermsAndConditions"
import Storage from "./util/Storage"
import { initialize } from "../src/components/reactGA"
import { GA_ID } from "./Config"
import MyAccount from "./views/MyAccount"
import Campaign from "./Campaign"
import BidPlacedSuccessfully from "./views/BidPlacedSuccessfully/BidPlacedSuccessfully"
import MyPlacedBids from "./views/MyPlacedBids/MyPlacedBids"

class App extends React.Component {
  constructor(props) {
    super(props)
    this.state = { hasError: false, popupType: "normal" }
  }

  componentDidMount() {
    console.log("Component Did Mount App.js")
  }

  componentWillMount() {
    let host = window.location.hostname
    let subDomain = host.split(".")[0]
    console.log(" SUB APP ", subDomain)
    if (subDomain === "epu") {
      Cookie.set("locale", "es")
    }

    const currentUrl = window.location.href
    if (currentUrl.includes("campaign")) {
      this.setState({
        popupType: "campaign",
      })
    }

    const newUserFlag = Storage.get("newUser")
    console.log("COVID POPUP ,", newUserFlag)
    if (Cookie.get("COVID_POPUP") == "1" || Cookie.get("COVID_POPUP") == "2") {
      console.log("COVID POP UP ", Cookie.get("COVID_POPUP"))
    } else {
      console.log("SHOW COVID POP UP ", Cookie.get("COVID_POPUP"))
      Cookie.set("COVID_POPUP", 0)
    }

    if (Cookie.get("COVID_POPUP") != "2" && newUserFlag != "true") {
      Cookie.set("COVID_POPUP", "1")
      console.log("SHOW COVID POP UP ", Cookie.get("COVID_POPUP"))
    }

    // Cookie.set("X-Reycreo-Auth-Token", "4ee6055b-1f2b-41f2-92a2-5bd558768929")
    // Cookie.set("X-Reycreo-Id", "BW_PH918010078100")
    // Cookie.set("lang", "en")
    // Cookie.set("freeBids", "5")
    // Cookie.set("newUser", "false")
    // Cookie.set("X-Reycreo-Operator-Id", "U2OPIADUMMY")
    // Cookie.set("oneSignalAppId", "da890b9e-7689-4b00-81c2-ee73cda292f9")

    const gaOptions = {}
    gaOptions.gaId = "UA-123279590-1"
    initialize("UA-123279590-1", { gaOptions })
  }

  componentDidUpdate() {
    let host = window.location.hostname
    let subDomain = host.split(".")[0]
    console.log(" SUB APP ", subDomain)
    if (subDomain === "epu") {
      Cookie.set("locale", "es")
    }
  }

  componentDidCatch(error, info) {
    // Display fallback UI
    this.setState({ hasError: true })
    console.error("Error :-", error, info)
  }

  render() {
    if (this.state.hasError) {
      return <h1>Something went wrong.</h1>
    }

    return (
      <Provider store={Store}>
        <MuiThemeProvider theme={theme}>
          <I18nextProvider i18n={i18n}>
            <Router>
              <div style={{ flex: 1, height: "100%", background: "#000" }}>
                <Switch>
                  <Route path='/play/enable-cookie' component={EnableCookie} />
                  <Route path='/play/contact-us' component={ContactUs} />
                  <Route path='/play/trending-bids' component={TrendingBids} />
                  <Route path='/play/daily-bids' component={DailyBids} />
                  <Route path='/play/weekly-bids' component={WeeklyBids} />
                  {/* <Route path='/play/all-bids' component={AllBids} /> */}
                  <Route
                    path='/play/product-details/:title/:offerId'
                    component={ProductDetails}
                  />
                  <Route path='/play/all-bids' component={WithLogin(AllBids)} />
                  <Route
                    path='/play/my-account'
                    component={WithLogin(MyAccount)}
                  />
                  <Route
                    path='/play/invite-and-earn'
                    component={WithLogin(InviteAndEarn)}
                  />
                  <Route path='/play/my-bids' component={MyPlacedBids} exact />
                  {/* <Route
                    path='/play/my-bids/:title/:offerId'
                    component={MyBids}
                    exact
                  /> */}
                  <Route
                    path='/play/my-bids'
                    component={WithLogin(MyPlacedBids)}
                    exact
                  />
                  <Route
                    path='/play/my-bids/:title/:offerId'
                    component={WithLogin(MyBids)}
                    exact
                  />
                  <Route
                    path='/play/my-bids/expired/:title/:offerId'
                    component={WithLogin(ExpiredBids)}
                    exact
                  />
                  <Route
                    path='/play/place-bids/:title/:offerId'
                    component={WithLogin(PlaceBids)}
                  />
                  <Route
                    path='/play/bid-placed-successfully/:title/:offerId'
                    component={WithLogin(BidPlacedSuccessfully)}
                  />
                  {/* <Route
                    path='/play/place-bids/:title/:offerId'
                    component={PlaceBids}
                  /> */}
                  <Route
                    exact
                    path='/play/terms-and-conditions'
                    component={TermsAndConditions}
                  />
                  <Route
                    exact
                    path='/play/testimonials'
                    component={Testimonials}
                  />
                  <Route
                    exact
                    path='/play/tnc'
                    component={LandingPageTermsAndConditions}
                  />
                  <Route
                    exact
                    path='/play/how-bid-works'
                    component={HowBidWorks}
                  />
                  <Route exact path='/play/data-saver' component={DataSaver} />
                  <Route exact path='/play/no-data' component={NoWifiPage} />
                  <Route path='/play/campaign' component={Campaign} />
                  <Route path='/play/' component={Main} />
                </Switch>
                <FullPageLoader />
                <Toast />
                <Popup type={this.state.popupType} />
                {isUser() && <OneSignal />}
              </div>
            </Router>
          </I18nextProvider>
        </MuiThemeProvider>
      </Provider>
    )
  }
}

export default App



// WEBPACK FOOTER //
// ./src/App.js